module.exports = __webpack_public_path__ + "static/media/SY.96bd6eba.png";